import AnimatedPage from './AnimatedPage';

import Intro from '../components/Intro';
import Separator from '../components/Separator';
import ContentBlocks from '../components/ContentBlocks';
import AnimatedImage from '../components/assets/AnimatedImage';
import UspSummary from '../components/UspSummary';
import PageBorder from '../components/PageBorder';
import About from '../components/About';
import ContentBlock from '../components/ContentBlock';
import Button from '../components/Button';
import { ButtonTypes } from '../setup/enum-buttontypes';

function Home() {
	return (
		<AnimatedPage title={'Welkom'}>
			<PageBorder>
				<Intro title="Dierenarts voor gezonde én gelukkige dieren" text="Diergeneeskundige zorg, osteopathie, chiropractie en orthomoleculaire therapie voor hond en kat." hideButtonMobile={true} />
				<Separator />
				<ContentBlocks>
					<div className="columnlayout__column offset1">
						<ContentBlock
							className="contentblocks__contentblock1 contentblock--white contentblock--mt"
							button={<Button link={'/overmij'} text={'Meer over mij'} type={ButtonTypes.ButtonIcon} />}
							content={
								<>
									<p>
										Ik ben Jolanda, <strong>dierenarts voor gezelschapsdieren</strong> in Noord-Holland. Daarnaast werk ik als orthomoleculair voedingsdeskundige, osteopaat en chiropractor voor honden en katten.
									</p>
								</>
							}
						/>
					</div>
					<div className="columnlayout__column">
						<ContentBlock
							className="contentblocks__contentblock3 contentblock--white"
							image={<AnimatedImage />}
							button={<Button link={'/advies'} text={'Advies'} type={ButtonTypes.ButtonIcon} />}
							content={
								<>
									<p>
										Orthomoleculaire therapie ondersteunt met passende voeding en supplementen de gezondheid van het dier, <strong>zowel preventief als bij gezondheidsproblemen</strong>. Voor elke hond of kat bied ik een <strong>orthomoleculair voedingsadvies</strong> op maat aan.
									</p>
									<p>
										<small className="text--italic">Op dit moment is er door drukte een wachttijd van ca. 2 maanden, maar neem gerust alvast contact op.</small>
									</p>
								</>
							}
						/>
					</div>
				</ContentBlocks>
				<UspSummary />
			</PageBorder>
			<About />
		</AnimatedPage>
	);
}

export default Home;
